import React, { useRef, useEffect, useState } from "react";
import {
  LocationFieldContainer,
  MainPolicyContainer,
  SubPolicyContainer,
  SubPolicyFieldContainer,
  SubPolicyModalContainer,
  SubPolicyModalHeader,
  PolicyActionButton,
  CreatePolicySection,
  SubPolicies,
  SelectStyles,
  LocationMainPolicyContainer,
  TextField,
  GeneralContainerCreatePolicy,
} from "./CreatePolicyContainer.styled";
import Select from "react-select";
import AddSubPolicy from "../../components/AddSubPolicy/AddSubPolicy";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { NotificationManager } from "react-notifications";
import {
  COUNTRIES_BY_CLIENT,
  CURRENT_USER_INFO,
  GET_LOBS,
} from "../../GraphQL/Queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import { theme as themeConfig } from "../../themes/themes";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { useHistory } from "react-router-dom";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as SiteManagementHeaderIcon } from "../../assets/svg/site-management-header-logo.svg";
import LockIcon from "@mui/icons-material/Lock";
import { CREATE_POLICY } from "../../GraphQL/Mutations";
import { clientPolicyIngsight } from "../../App";
import { ROLES } from "../../util/RolesConstants";

const CreatePolicyContainer = () => {
  const rLocation = useRef("");
  const user = getStateLoginComplete();
  const [locationOptions, setLocationOptions] = useState([]);
  const [locationValue, setLocationValue] = useState(0);
  const [subPolicyComponent, setSubPolicyComponent] = useState([]);
  const [mainPolicy, setMainPolicy] = useState("");
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const history = useHistory();
  const [lobsOption, setLobsOption] = useState([]);
  const [locationDefaultValue, setLocationDefaultValue] = useState({});
  const [createPolicy] = useMutation(CREATE_POLICY, {
    client: clientPolicyIngsight,
  });
  const [showSavePolicyLoader, setShowSavePolicyLoader] = useState(false);

  const [runQueryUserInfo] = useLazyQuery(CURRENT_USER_INFO, {
    context: { clientName: "LinkUsers" },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      console.log(data)
      if (data?.currentUser[0]?.userId) {
        let userDetail = data?.currentUser[0];
        /* Setting User's country id for country admin role and Supervisor role */
        console.log(userDetail)
        setLocationValue(userDetail?.location?.countryId);
      }

    },
  });


  const [runQueryCountry, { loading: loadingCountries }] = useLazyQuery(
    COUNTRIES_BY_CLIENT,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllCountries = data.countryLocationList.map((element) => {
          return {
            value: element?.countryId,
            label: element?.countryName,
          };
        });
        console.log(resultOfAllCountries)
        setLocationOptions(resultOfAllCountries);
      },
      error: (err) => {
        NotificationManager.warning("error");
      },
    }
  );

  const [runQueryLobsByCountry, { loading: lobsLoading }] = useLazyQuery(
    GET_LOBS,
    {
      fetchPolicy: "network-only",
      onCompleted: (res) => {
        let resultOfLobs = res?.lobsListByCountry?.map((element) => {
          return {
            value: element?.lobId,
            label: element?.lobName,
          };
        });
        setLobsOption(resultOfLobs);
      },
      onError: (error) => {
        NotificationManager.error(error.message, "", 5000);
      },
    }
  );

  useEffect(() => {
    if (user?.clientId) {
      runQueryCountry({
        variables: { clientId: user.clientId },
        context: { clientName: "LinkUsers" },
      });
    }

    if (
      user.roleId === ROLES.COUNTRY_ADMIN ||
      user.roleId === ROLES.SUPERVISOR
    ) {
      runQueryUserInfo();
    }
  }, []);

  useEffect(() => {
    console.log(locationValue)
    if (locationValue > 0) {
      runQueryLobsByCountry({
        variables: {
          countryId: locationValue,
        },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [locationValue]);

  useEffect(() => {
    if (
      (user.roleId === ROLES.COUNTRY_ADMIN ||
        user.roleId === ROLES.SUPERVISOR) &&
      locationValue > 0
    )
      setLocationDefaultValue(
        locationOptions.find((x) => x.value === locationValue)
      );
  }, [locationValue, locationOptions]);

  const handleAddPolicy = () => {
    let arr = [...subPolicyComponent];
    arr.unshift({
      id: arr.length,
      subPolicyName: "",
      lobIds: [],
    });
    setSubPolicyComponent(arr);
  };

  const deleteSubPolicy = (id) => {
    let arr = subPolicyComponent.filter((policy) => policy.id !== id);
    setSubPolicyComponent(arr);
  };

  const onChangeLobs = (val, id) => {
    let arr = subPolicyComponent;
    arr.forEach((policy) => {
      if (policy.id === id) {
        policy.lobIds = val;
      }
    });
    setSubPolicyComponent(arr);
  };

  const onChangePolicy = (val, id) => {
    let arr = subPolicyComponent;
    arr.forEach((policy) => {
      if (policy.id === id) {
        policy.subPolicyName = val;
      }
    });
    setSubPolicyComponent(arr);
  };

  const validateMandatoryFields = () => {
    let error = false;
    if (mainPolicy.trim() === "") {
      error = true;
    }
    if (subPolicyComponent.length > 0) {
      subPolicyComponent.forEach((policy) => {
        if (policy.subPolicyName === "" || policy.lobIds.length === 0) {
          error = true;
        }
      });
    } else {
      error = true;
    }
    return error;
  };

  const handleCreatePolicy = (data) => {
    setShowSavePolicyLoader(true);
    createPolicy({
      variables: {
        mainPolicyName: data.mainPolicyName,
        countryId: data.countryId,
        subPolicies: data.subPolicies,
      },
    })
      .then((res) => {
        if (res?.data?.createPolicy?.idMainPolicy) {
          NotificationManager.success("Policy created successfully");
          history.push({
            pathname: "/InternalDataManagement",
            state: { tab: 2 },
          });
        } else {
          NotificationManager.error("Something went wrong in creating policy");
        }
        setShowSavePolicyLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setShowSavePolicyLoader(false);
      });
  };

  const onSaveClick = () => {
    const hasError = validateMandatoryFields();
    if (hasError) {
      NotificationManager.warning("Please fill all the manadatory fields");
    } else {
      const subPolicies = subPolicyComponent.map((data) => {
        return {
          subPolicyName: data.subPolicyName,
          lobIds: data.lobIds.map((data) => {
            return parseInt(data.value);
          }),
        };
      });

      const data = {
        mainPolicyName: mainPolicy,
        countryId: locationValue,
        subPolicies: subPolicies,
      };
      handleCreatePolicy(data);
    }
  };

  return (
    <GeneralContainerCreatePolicy>
      <div>
        <HeaderComponent
          Icon={SiteManagementHeaderIcon}
          text={"Site Management"}
        />
      </div>
      <CreatePolicySection>
        <div style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
          <BackButtonComponent
            backtitle={"Policies"}
            locationtitle={"Create Policy"}
            goToBackPage={() =>
              history.push({
                pathname: "/InternalDataManagement",
                state: { tab: 2 },
              })
            }
            identity={"createUpdatePolicy"}
          />
        </div>
        <SubPolicyModalContainer>
          <SubPolicyModalHeader>
            <label>Create Policy</label>
          </SubPolicyModalHeader>
          <LocationMainPolicyContainer>
            <LocationFieldContainer>
              <label className="heading-label">Location</label>
              {(user.roleId === ROLES.SUPER_ADMIN ||
                user.roleId === ROLES.GAM) && (
                  <div className="location-dropdown">
                    <Select
                      styles={SelectStyles}
                      placeholder="Select an option"
                      ref={rLocation}
                      isDisabled={
                        user.roleId === ROLES.COUNTRY_ADMIN ||
                        user.roleId === ROLES.SUPERVISOR
                      }
                      options={locationOptions}
                      onChange={(option) => {
                        setLocationValue(option.value);
                      }}
                    // value={locationDefaultValue}
                    />
                  </div>
                )}
              {(user.roleId === ROLES.COUNTRY_ADMIN ||
                user.roleId === ROLES.SUPERVISOR) && (
                  <TextField>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ position: "relative" }}>
                        <input
                          style={{ backgroundColor: themeConfig.neutral.gray[200] }}
                          type="text"
                          defaultValue={locationDefaultValue?.label}
                          disabled
                        />
                        <LockIcon className="lock-icon" />
                      </div>
                    </div>
                  </TextField>
                )}
            </LocationFieldContainer>
            <MainPolicyContainer>
              <label className="heading-label">
                Main Policy <span className="mandatory">*</span>
              </label>
              <input
                placeholder="Enter Main Policy"
                disabled={
                  locationValue === 0 &&
                    (user.roleId === ROLES.SUPER_ADMIN ||
                      user.roleId === ROLES.GAM)
                    ? true
                    : false
                }
                onChange={(val) => {
                  setMainPolicy(val.target.value);
                }}
              />
            </MainPolicyContainer>
          </LocationMainPolicyContainer>
          <SubPolicyContainer>
            <SubPolicyFieldContainer>
              <button
                className="add-policy-btn"
                onClick={handleAddPolicy}
                disabled={
                  locationValue === 0 &&
                    (user.roleId === ROLES.SUPER_ADMIN ||
                      user.roleId === ROLES.GAM)
                    ? true
                    : false
                }
              >
                <span>+</span>
                Add Sub Policy
              </button>
            </SubPolicyFieldContainer>
            {subPolicyComponent.length > 0 && (
              <SubPolicies>
                {subPolicyComponent.map((subpolicy, index) => {
                  return (
                    <AddSubPolicy
                      key={subpolicy.id}
                      id={subpolicy.id}
                      deleteSubPolicy={deleteSubPolicy}
                      lobsOnChange={onChangeLobs}
                      subPolicyOnChange={onChangePolicy}
                      index={subpolicy.id + 1}
                      lobsOption={lobsOption}
                    />
                  );
                })}
              </SubPolicies>
            )}
          </SubPolicyContainer>
          <PolicyActionButton>
            <button
              className="cancel-btn"
              onClick={() => setShowCancelConfirmation(true)}
            >
              Cancel
            </button>
            <button onClick={onSaveClick}>Save</button>
          </PolicyActionButton>
          {showCancelConfirmation && (
            <ConfirmationModal
              getCancelConfirmation={() => {
                setShowCancelConfirmation(false);
              }}
              getSuccessConfirmation={() => {
                history.push({
                  pathname: "/InternalDataManagement",
                  state: { tab: 2 },
                });
              }}
              title={"System alert"}
              content={"If you cancel the process now, no changes will saves"}
              cancelConfirmation={"Cancel"}
              sccessConfirmation={"Leave"}
            />
          )}
          {(showSavePolicyLoader || loadingCountries || lobsLoading) && (
            <ModalLoader />
          )}
        </SubPolicyModalContainer>
      </CreatePolicySection>
    </GeneralContainerCreatePolicy>
  );
};

export default CreatePolicyContainer;
